import { Component, Input } from '@angular/core';
import { ApiV1Job } from '@bluecrew/crew-member-backend-angular-client';
import { openGoogleMaps } from '../../util/google-maps-utils';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';

@Component({
  selector: 'app-job-commute',
  templateUrl: './job-commute.component.html',
  styleUrls: ['./job-commute.component.scss'],
})
export class JobCommuteComponent {
  @Input() job: ApiV1Job;
  @Input() sourcePage: string;

  constructor(
    private readonly segmentCMOS: SegmentCMOSService
  ) { }

  onCommuteTimeButtonClick() {
    this.segmentCMOS.addEvent(`click_jobCommuteCard`, {
      jobId: this.job.legacyExternalJobId,
      sourcePage: this.sourcePage
    });
    openGoogleMaps(this.job);
  }
}
